import React from 'react'
import Header from './components/Header';
import { Outlet, useMatches } from 'react-router-dom';
import { Breadcrumb, message } from 'antd';




const Layout = () => {
  const [messageApi, contextHolder] = message.useMessage();

  let matches = useMatches();
  let crumbs = matches 
    // first get rid of any matches that don't have handle and crumb
    .filter((match) => Boolean(match.handle?.crumb))
    // now map them into an array of elements, passing the loader
    // data to each one 
    .map((match) => match.handle.crumb(match.data));


    
  const success = (message) => {
    messageApi.open({
      type: 'success',
      content: message,
    });
  };

  const error = (message) => {
    messageApi.open({
      type: 'error',
      content: message,
    });
  };

  const CustomBreadcrumb = () => {
    return (
      <Breadcrumb>
        {crumbs.map((crumb, idx) => 
          <Breadcrumb.Item key={idx}>{crumb}</Breadcrumb.Item>
        )}
      </Breadcrumb>
    )
  };

  return (
    <div className='bg-slate-100'>
      <Header />
      {contextHolder}
      <div className=''>
        <Outlet context={{success, error, CustomBreadcrumb}}/>
      </div>
    </div>
  )
}

export default Layout;